import { FranchiseData } from '../config/api'

export function getWhatsAppNumber(franchiseData?: FranchiseData | null): string | null {
  if (!franchiseData) return null

  const raw = franchiseData.whatsapp || franchiseData.telephone || franchiseData.emergency_telephone
  if (!raw) return null

  const digits = raw.replace(/[^\d]/g, '')
  return digits || null
}

export function getWhatsAppUrl(
  franchiseData?: FranchiseData | null,
  message?: string
): string {
  const number = getWhatsAppNumber(franchiseData)
  if (!number) return '/contact'

  const query = message ? `?text=${encodeURIComponent(message)}` : ''
  return `https://wa.me/${number}${query}`
}
